function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
}

const clusterReducer = (state, action) => {
    if (state === undefined) {
        state = {
            clusters: null,
            /*clusters: {
                1: {
                    id: 1,
                    user_id: 2,
                    title: "Klaster 1",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    col_1_name: "SVK",
                    col_2_name: "EN",
                    col_3_name: "HUN",
                    shared_with: [
                        {
                            id: 1,
                            first_name: "Matej",
                            last_name: "Janeček",
                            email: "matej@email.sk",
                        },
                        {
                            id: 2,
                            first_name: "Jakub",
                            last_name: "Hubert",
                            email: "hubert@email.sk",
                        }
                    ]
                },
                2: {
                    id: 2,
                    user_id: 2,
                    title: "Klaster 2",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    col_1_name: "SVK",
                    col_2_name: "EN",
                    col_3_name: "HUN",
                    shared_with: []
                },
                3: {
                    id: 3,
                    user_id: 2,
                    title: "Klaster 3",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    col_1_name: "SVK",
                    col_2_name: "EN",
                    col_3_name: "HUN",
                    shared_with: []
                }
            },*/
            cluster_rows: {},
            /*cluster_rows: {
                1: [
                    {id: 1, col_1: "A", col_2: "2", col_3: "3"},
                    {id: 2, col_1: "B", col_2: "2", col_3: "3"},
                    {id: 3, col_1: "C", col_2: "2", col_3: "3"},
                ]
            },*/
            error: null,
            data_error: null
        };
        return state;
    }
    let new_state, index, index2;
    let clusterIndex;
    switch (action.type) {
        case "SET_CLUSTERS":
            return {
                ...state,
                clusters: action.clusters
            };
        case "UPDATE_CLUSTER":
            index = state.clusters.findIndex(cluster => cluster.id === action.cluster.id)
            return {
                ...state,
                clusters: [
                    ...state.clusters.slice(0, index),
                    action.cluster,
                    ...state.clusters.slice(index + 1)
                ],
                error: null
            };
        case "ADD_CLUSTER":
            return {
                ...state,
                clusters: [
                    ...state.clusters,
                    action.cluster
                ],
                error: null
            };
        case "REMOVE_CLUSTER":
            index = state.clusters.findIndex(cluster => cluster.id === action.cluster.id)
            return {
                ...state,
                clusters: [
                    ...state.clusters.slice(0, index),
                    ...state.clusters.slice(index + 1)
                ],
                error: null
            };
        case "SET_CLUSTER_ERROR":
            return {
                ...state,
                error: action.error
            };
        case "CLEAR_CLUSTER_ERROR":
            return {
                ...state,
                error: null
            };
        case "ADD_CLUSTER_SHARE":
            index = state.clusters.findIndex(cluster => cluster.id === action.cluster_id)
            return {
                ...state,
                clusters: [
                    ...state.clusters.slice(0, index),
                    {
                        ...state.clusters[index],
                        shared_with: [
                            ...state.clusters[index].shared_with,
                            action.share
                        ]
                    },
                    ...state.clusters.slice(index + 1)
                ]
            };
        case "REMOVE_CLUSTER_SHARE":
            clusterIndex = state.clusters.findIndex(cluster => cluster.id === action.cluster_id);
            let shareIndex = state.clusters[clusterIndex].shared_with.findIndex(share => share.id === action.user_id);
            return {
                ...state,
                clusters: [
                    ...state.clusters.slice(0, clusterIndex),
                    {
                        ...state.clusters[clusterIndex],
                        shared_with: [
                            ...state.clusters[clusterIndex].shared_with.slice(0, shareIndex),
                            ...state.clusters[clusterIndex].shared_with.slice(shareIndex + 1),
                        ]
                    },
                    ...state.clusters.slice(clusterIndex + 1)
                ]
            };
        case "SET_CLUSTER_SHARE_ERROR":
            return {
                ...state,
                share_error: action.error
            };
        case "CLEAR_CLUSTER_SHARE_ERROR":
            return {
                ...state,
                share_error: null
            };
        case "SET_CLUSTER_DATA":
            return {
                ...state,
                cluster_rows: {
                    ...state.cluster_rows,
                    [action.cluster_id]: action.rows
                }
            };
        /*case "CHANGE_CLUSTER_DATA_ROW_ORDER":
            let sourceIndex = state.cluster_rows[action.cluster_id].findIndex(row => row.id === action.source.id);
            let targetIndex = state.cluster_rows[action.cluster_id].findIndex(row => row.id === action.destination.id);
            new_state = {
                ...state
            };
            array_move(new_state.cluster_rows[action.cluster_id], sourceIndex, targetIndex);
            for(let i in new_state.cluster_rows[action.cluster_id]){
                new_state.cluster_rows[action.cluster_id][i].row_number = i;
            }
            return new_state;

*/
        case "UPDATE_CLUSTER_DATA_ROW":
            let rowIndex = state.cluster_rows[action.cluster_id].findIndex(row => row.id === action.row.id);
            if (rowIndex === -1) return state;
            return {
                ...state,
                cluster_rows: {
                    ...state.cluster_rows,
                    [action.cluster_id]: [
                        ...state.cluster_rows[action.cluster_id].slice(0, rowIndex),
                        action.row,
                        ...state.cluster_rows[action.cluster_id].slice(rowIndex + 1),
                    ]
                }
            };
        case "ADD_CLUSTER_DATA_ROW":
            return {
                ...state,
                cluster_rows: {
                    ...state.cluster_rows,
                    [action.cluster_id]: [
                        ...state.cluster_rows[action.cluster_id],
                        action.row
                    ]
                }
            };
        case "REMOVE_CLUSTER_DATA_ROW":
            index = state.cluster_rows[parseInt(action.cluster_id)].findIndex(obj => obj.id === action.row_id);
            new_state = {
                ...state,
                cluster_rows: {
                    ...state.cluster_rows,
                    [parseInt(action.cluster_id)]:
                        [
                            ...state.cluster_rows[parseInt(action.cluster_id)].slice(0, index),
                            ...state.cluster_rows[parseInt(action.cluster_id)].slice(index + 1)
                        ]
                }
            };
            return new_state;
        case "SET_CLUSTER_DATA_ERROR":
            return {
                ...state,
                data_error: null
            };
        default:
            return state;
    }
};
export default clusterReducer;